import Axios from "../services/axios.service";

export class RemittanceService {
  static async fetchRemittances(page, chargeCategory, size) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/fee-management/list-charges-fees?page=${page}&chargeCategory=${chargeCategory}&size=${size}`,
    });
  }

  static async deleteRemittance(id) {
    return Axios({
      method: "DELETE",
      url: `web-services/api/v6/services/admin/fee-management/delete-fee/${id}`,
    });
  }

  static async fetchRemittancesFeeSettings() {
    return Axios({
      method: "GET",
      url: "web-services/api/v6/services/admin/organisation-preference-management/fetch-organisaction-preference",
    });
  }

  static async updateRemittancesFeeSettings(payload) {
    return Axios({
      method: "PUT",
      url: "web-services/api/v6/services/admin/organisation-preference-management/update-organisaction-preference",
      data: payload,
    });
  }

  static async ipWhiteListSetting(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/security/ip-whitelisting-setting`,
      data: payload,
    });
  }

  static async twoFactorAuthSetting(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/security/twofactor-auth-setting`,
      data: payload,
    });
  }

  static async transactionPinAndScaSetting(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/security/save-strong-customer-auth`,
      data: payload,
    });
  }

  static async viewPasswordPolicy() {
    return Axios({
      method: "GET",
      url: "web-services/api/v6/services/admin/security/view-password-policy",
    });
  }

  static async savePasswordPolicy(payload) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/security/save-password-policy`,
      data: payload,
    });
  }

  static async taxSetting(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/taxmanagement/create-tax-setting`,
      data: payload,
    });
  }

  static async addBandRate(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/fee-management/add-band-fee`,
      data: payload,
    });
  }

  static async addFixedAmountFee(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/fee-management/add-default-charge`,
      data: payload,
    });
  }

  static async listDefaultChargeForPaymentMethod() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/fee-management/list-default-charge-fees?deliveryMethod=PAYMENT_METHOD`,
    });
  }

  static async listDefaultChargeForFixedAmountFee(deliveryMethod) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/fee-management/list-default-charge-fees?deliveryMethod=${deliveryMethod}`,
    });
  }
}
